import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Payment Method", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["required"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value", "disabled"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "form-field"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "First name", -1)
const _hoisted_9 = {
  key: 1,
  class: "form-field"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Last name", -1)
const _hoisted_11 = { class: "form-field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Card Number", -1)
const _hoisted_13 = {
  key: 2,
  class: "form-field"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Card Type", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "form-field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Expiration Month/Year", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "form-field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "CVV", -1)
const _hoisted_22 = { key: 2 }
const _hoisted_23 = {
  key: 0,
  class: "form-field"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Account holder first name", -1)
const _hoisted_25 = {
  key: 1,
  class: "form-field"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", null, "Account holder last name", -1)
const _hoisted_27 = { class: "form-field" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, "Account type", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "checking" }, "Checkings", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "savings" }, "Savings", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "businessChecking" }, "Business Checking", -1)
const _hoisted_32 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = {
  key: 2,
  class: "form-field"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, "Bank Name", -1)
const _hoisted_35 = { class: "form-field" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "Routing number", -1)
const _hoisted_37 = { class: "form-field" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", null, "Account number", -1)
const _hoisted_39 = {
  key: 3,
  class: "form-field"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", null, "Account number confirmation", -1)
const _hoisted_41 = { key: 3 }
const _hoisted_42 = {
  key: 0,
  class: "form-field"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", null, "Name on Check", -1)
const _hoisted_44 = { class: "form-field" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", null, "Check Number", -1)
const _hoisted_46 = { class: "form-field" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", null, "Check Amount", -1)
const _hoisted_48 = { key: 4 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", null, " Use as autopay method", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h3", null, "Billing Address", -1)
const _hoisted_52 = { class: "form-field" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", null, "Address Line 1", -1)
const _hoisted_54 = {
  key: 0,
  class: "form-field"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", null, "Address Line 2", -1)
const _hoisted_56 = {
  key: 1,
  class: "form-field"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", null, "City", -1)
const _hoisted_58 = { class: "form-field" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", null, "State/Province", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "Select State", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", null, "Zip", -1)
const _hoisted_62 = { key: 2 }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", null, "Country", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "Select Country", -1)
const _hoisted_65 = { key: 3 }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", null, " Save as a reuseable payment", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("small", null, "This will save the payment option as an active payment account", -1)

import { ref, onMounted, watch } from "vue";
import { paymentAccountInterface } from "@/types/customers";
import BaseSpinner from "@/components/BaseSpinner.vue";

import moment from "moment";
import { storeToRefs } from "pinia";
import { useStore } from "../store";
import api from "@virgodev/bazaar/functions/api";

export default /*#__PURE__*/_defineComponent({
  props: {
  facilityId: {
    type: String,
    default: null,
  },
  customerId: {
    type: String,
    required: true,
  },
},
  emits: ["paymentMethod"],
  setup(__props, { emit }) {

const props = __props

const formErrors = ref<Record<string, string[]>>({});

const errors = ref("");
const customer = ref();
const status = ref("loading");
const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;

const states = [
  "AL",
  "AB",
  "AK",
  "AS",
  "AZ",
  "AR",
  "BC",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "GU",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "MB",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "NB",
  "NL",
  "NS",
  "NU",
  "NT",
  "MP",
  "OH",
  "OK",
  "ON",
  "OR",
  "PA",
  "PEI",
  "PR",
  "QC",
  "RI",
  "SC",
  "SD",
  "SK",
  "TN",
  "TX",
  "TT",
  "VI",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
  "YT",
];
const countryList = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",
  "Austria",
  "Belgium",
  "Brazil",
  "Bulgaria",
  "Croatia",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hungary",
  "Ireland",
  "Latvia",
  "Lituania",
  "Luxembourg",
  "Malta",
  "Netherlands",
  "New Zealand",
  "Poland",
  "Portugal",
  "Romania",
  "Russian Federation",
  "Slovakia",
  "Slovenia",
  "South Africa",
  "Spain",
  "Sweden",
  "Switzerland",
  "Thailand",
  "United Arab Emirates (the)",
];
const paymentMethod = ref();
const creditCardTypes = ref();
const expirationMonth = ref();
const expirationYear = ref();
const paymentOptions = ref([
  { text: "Credit Card", value: "credit_card", disabled: false },
  { text: "ACH", value: "ach", disabled: false },
  { text: "Check", value: "check", disabled: false },
]);
const paymentAccounts = ref(Array<paymentAccountInterface>());
const months = ref();
const years = ref();

function savedPaymentKind(value: string | number | null | undefined) {
  const account = paymentAccounts.value.find((item) => item.id == value);
  return account?.kind || account?.payment_method?.kind || null;
}
const formFields = ref({
  payment_method: {
    payment_method_id: ref(),
    card_type_id: ref(),
    kind: ref(),
    reuseable: ref(false),
    first_name: ref(),
    last_name: ref(),
    card_number: ref(),
    card_type: ref(),
    security_code: ref(),
    account_type: ref(),
    bank_name: ref(),
    routing_number: ref(),
    account_number: ref(),
    account_number_confirmation: ref(),
    name_on_check: ref(),
    check_number: ref(),
    check_amount: ref(),
    expiration_date: ref(),
    autopay_enabled: ref(false),
    autopay_day: ref(1),
    billing_address_attributes: {
      address1: ref(),
      address2: ref(),
      city: ref(),
      state: ref(),
      postal: ref(),
      country: ref(),
    },
  },
});
const paymentDetails = ref();
onMounted(async () => {
  await getCreditCardTypes();
  await getCustomer();
  await getPaymentAccounts();
  moment.locale("en");
  months.value = moment.months();
  let current_year = moment().year();
  let end_year = Number(current_year) + 20;
  let year_list = [];
  for (let i = Number(current_year); i <= end_year; i++) {
    year_list.push(i);
  }
  years.value = year_list;
  if (!api_settings.allow_check_payment) {
    paymentOptions.value = [
      { text: "Credit Card", value: "credit_card", disabled: false },
      { text: "ACH", value: "ach", disabled: false },
    ];
  }
  if (api_settings.payment_link) {
    paymentOptions.value = [
      { text: "Payment Link", value: "payment_link", disabled: false },
    ];
  }
  if (
    paymentOptions.value.length === 1 &&
    paymentOptions.value[0].value === "payment_link" &&
    !paymentAccounts.value.length
  ) {
    paymentMethod.value = "payment_link";
  }
  status.value = "completed";
});
async function getCreditCardTypes() {
  errors.value = "";
  const response = await api({
    url: `credit_card_types/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    creditCardTypes.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
watch(paymentMethod, () => {
  if (["credit_card", "ach", "payment_link"].includes(paymentMethod.value)) {
    paymentDetails.value = null;
    formFields.value.payment_method.payment_method_id = null;
    if (!formFields.value.payment_method.first_name) {
      formFields.value.payment_method.first_name = customer.value.first_name;
    }
    if (!formFields.value.payment_method.last_name) {
      formFields.value.payment_method.last_name = customer.value.last_name;
    }
    if (customer.value.addresses) {
      if (
        !formFields.value.payment_method.billing_address_attributes.address1
      ) {
        formFields.value.payment_method.billing_address_attributes.address1 =
          customer.value.addresses[0].address1;
      }
      if (
        !formFields.value.payment_method.billing_address_attributes.address2
      ) {
        formFields.value.payment_method.billing_address_attributes.address2 =
          customer.value.addresses[0].address2;
      }
      if (!formFields.value.payment_method.billing_address_attributes.city) {
        formFields.value.payment_method.billing_address_attributes.city =
          customer.value.addresses[0].city;
      }
      if (!formFields.value.payment_method.billing_address_attributes.state) {
        formFields.value.payment_method.billing_address_attributes.state =
          customer.value.addresses[0].state;
      }
      if (!formFields.value.payment_method.billing_address_attributes.postal) {
        formFields.value.payment_method.billing_address_attributes.postal =
          customer.value.addresses[0].postal;
      }
      if (!formFields.value.payment_method.billing_address_attributes.country) {
        formFields.value.payment_method.billing_address_attributes.country =
          customer.value.addresses[0].country;
      }
    }
  } else if (
    paymentMethod.value != "check" &&
    api_settings.saved_payment_details
  ) {
    formFields.value.payment_method.payment_method_id = null;
    paymentDetails.value = paymentAccounts.value.filter(
      (item) => item.id == paymentMethod.value
    )[0];
    if (paymentDetails.value) {
      if (paymentDetails.value.expiration_month[0] == "0") {
        paymentDetails.value.expiration_month =
          paymentDetails.value.expiration_month[1];
      }
      expirationMonth.value = paymentDetails.value.expiration_month;
      expirationYear.value = paymentDetails.value.expiration_year;
      formFields.value.payment_method = paymentDetails.value.payment_method;
      let card_type_id = paymentDetails.value.payment_method.card_type_id;
      if (card_type_id) {
        formFields.value.payment_method.card_type =
          creditCardTypes.value.filter(
            (item: { id: number }) => item.id == card_type_id
          )[0].category_num;
      }
    }
  }
  emitPaymentMethod();
});
watch(formFields.value, () => {
  if (formFields.value.payment_method.autopay_enabled) {
    formFields.value.payment_method.reuseable = true;
  }
  emitPaymentMethod();
});
function emitPaymentMethod() {
  if (
    !["credit_card", "ach", "check", "payment_link"].includes(
      paymentMethod.value
    )
  ) {
    formFields.value.payment_method.payment_method_id = paymentMethod.value;
    formFields.value.payment_method.kind = savedPaymentKind(
      paymentMethod.value
    );
  } else {
    formFields.value.payment_method.kind = paymentMethod.value;
    if (paymentMethod.value == "credit_card") {
      if (api_settings.use_unit_id_for_transaction) {
        if (formFields.value.payment_method.card_type) {
          formFields.value.payment_method.card_type_id =
            creditCardTypes.value.filter(
              (item: { category_num: string }) =>
                item.category_num == formFields.value.payment_method.card_type
            )[0].id;
        }
      }
    }
  }
  if (expirationMonth.value && expirationYear.value) {
    let month = expirationMonth.value;
    if (month.toString().length == 1) {
      month = "0" + month.toString();
    }
    formFields.value.payment_method.expiration_date =
      month +
      "/" +
      expirationYear.value.toString()[2] +
      expirationYear.value.toString()[3];
  }

  emit("paymentMethod", formFields.value);
}
async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    customer.value = response.body[0];
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function getPaymentAccounts() {
  errors.value = "";
  const response = await api({
    url: `payment_accounts/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    paymentAccounts.value = response.body;
    if (api_settings.filter_payment_accounts) {
      paymentAccounts.value = response.body.filter(
        (item: { account: number; card_number: number }) =>
          item.account || item.card_number
      );
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 0,
          preset: "large"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (paymentAccounts.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((paymentMethod).value = $event)),
                  class: "form-select",
                  required: _unref(api_settings).require_payment_with_rental
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentAccounts.value, (account) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: account.id + 'account',
                      value: account.id
                    }, [
                      _createTextVNode(_toDisplayString(account.kind) + " " + _toDisplayString(account.card_number) + " " + _toDisplayString(account.account_type) + " " + _toDisplayString(account.account_number) + " ", 1),
                      (account.expiration_date)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" exp " + _toDisplayString(account.expiration_date), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_4))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentOptions.value, (method) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: method.value + 'payment',
                      value: method.value,
                      disabled: method.disabled
                    }, _toDisplayString(method.text), 9, _hoisted_5))
                  }), 128))
                ], 8, _hoisted_3), [
                  [_vModelSelect, paymentMethod.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (paymentMethod.value == 'credit_card' || paymentDetails.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_unref(api_settings).payment_tenant_name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.payment_method.first_name) = $event)),
                        type: "text",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formFields.value.payment_method.first_name]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(api_settings).payment_tenant_name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.payment_method.last_name) = $event)),
                        type: "text",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formFields.value.payment_method.last_name]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formFields.value.payment_method.card_number) = $event)),
                    type: "text",
                    required: ""
                  }, null, 512), [
                    [_vModelText, formFields.value.payment_method.card_number]
                  ])
                ]),
                (_unref(api_settings).show_card_types)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formFields.value.payment_method.card_type) = $event)),
                        class: "form-select",
                        required: ""
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(creditCardTypes.value, (card) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: card,
                            value: 
              _unref(api_settings).use_unit_id_for_transaction
                ? card.category_num
                : card
            
                          }, _toDisplayString(_unref(api_settings).use_unit_id_for_transaction ? card.description : card), 9, _hoisted_15))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, formFields.value.payment_method.card_type]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((expirationMonth).value = $event)),
                    class: "form-select",
                    required: "",
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (emitPaymentMethod()))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(months.value, (month, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: month,
                        value: index + 1
                      }, _toDisplayString(index + 1) + " - " + _toDisplayString(month), 9, _hoisted_18))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, expirationMonth.value]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((expirationYear).value = $event)),
                    class: "form-select",
                    required: "",
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (emitPaymentMethod()))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(years.value, (year) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: year + 'year',
                        value: year
                      }, _toDisplayString(year), 9, _hoisted_19))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, expirationYear.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formFields.value.payment_method.security_code) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.payment_method.security_code]
                  ])
                ])
              ]))
            : (paymentMethod.value == 'ach')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  (_unref(api_settings).payment_tenant_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _hoisted_24,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formFields.value.payment_method.first_name) = $event)),
                          type: "text",
                          required: ""
                        }, null, 512), [
                          [_vModelText, formFields.value.payment_method.first_name]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(api_settings).payment_tenant_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _hoisted_26,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formFields.value.payment_method.last_name) = $event)),
                          type: "text",
                          required: ""
                        }, null, 512), [
                          [_vModelText, formFields.value.payment_method.last_name]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formFields.value.payment_method.account_type) = $event)),
                      class: "form-select",
                      type: "text",
                      required: ""
                    }, _hoisted_32, 512), [
                      [_vModelSelect, formFields.value.payment_method.account_type]
                    ])
                  ]),
                  (_unref(api_settings).payment_tenant_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _hoisted_34,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formFields.value.payment_method.bank_name) = $event)),
                          type: "text",
                          required: ""
                        }, null, 512), [
                          [_vModelText, formFields.value.payment_method.bank_name]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formFields.value.payment_method.routing_number) = $event)),
                      type: "text",
                      required: ""
                    }, null, 512), [
                      [_vModelText, formFields.value.payment_method.routing_number]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formFields.value.payment_method.account_number) = $event)),
                      type: "text",
                      required: ""
                    }, null, 512), [
                      [_vModelText, formFields.value.payment_method.account_number]
                    ])
                  ]),
                  (_unref(api_settings).payment_account_confirmation)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _hoisted_40,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formFields.value.payment_method.account_number_confirmation) = $event)),
                          type: "text",
                          required: ""
                        }, null, 512), [
                          [_vModelText, formFields.value.payment_method.account_number_confirmation]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (paymentMethod.value == 'check')
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    (_unref(api_settings).payment_tenant_name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _hoisted_43,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formFields.value.payment_method.name_on_check) = $event)),
                            type: "text",
                            required: ""
                          }, null, 512), [
                            [_vModelText, formFields.value.payment_method.name_on_check]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formFields.value.payment_method.check_number) = $event)),
                        type: "text",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formFields.value.payment_method.check_number]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formFields.value.payment_method.check_amount) = $event)),
                        type: "text",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formFields.value.payment_method.check_amount]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
          (_unref(api_settings).allow_autopay_changes)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formFields.value.payment_method.autopay_enabled) = $event)),
                  class: "form-check-input",
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, formFields.value.payment_method.autopay_enabled]
                ]),
                _hoisted_49,
                _hoisted_50
              ]))
            : _createCommentVNode("", true),
          (
        (paymentMethod.value && ['credit_card', 'ach'].includes(paymentMethod.value)) ||
        paymentDetails.value
      )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((
            formFields.value.payment_method.billing_address_attributes.address1
          ) = $event)),
                    type: "text",
                    required: ""
                  }, null, 512), [
                    [_vModelText, 
            formFields.value.payment_method.billing_address_attributes.address1
          ]
                  ])
                ]),
                (_unref(api_settings).payment_address2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                      _hoisted_55,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((
            formFields.value.payment_method.billing_address_attributes.address2
          ) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, 
            formFields.value.payment_method.billing_address_attributes.address2
          ]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(api_settings).payment_city)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _hoisted_57,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formFields.value.payment_method.billing_address_attributes.city) = $event)),
                        type: "text",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formFields.value.payment_method.billing_address_attributes.city]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formFields.value.payment_method.billing_address_attributes.state) = $event)),
                    class: "form-select",
                    required: ""
                  }, [
                    _hoisted_60,
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(states, (state) => {
                      return _createElementVNode("option", { key: state }, _toDisplayString(state), 1)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, formFields.value.payment_method.billing_address_attributes.state]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_61,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formFields.value.payment_method.billing_address_attributes.postal) = $event)),
                    type: "text",
                    required: ""
                  }, null, 512), [
                    [_vModelText, formFields.value.payment_method.billing_address_attributes.postal]
                  ])
                ]),
                (_unref(api_settings).payment_country)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _hoisted_63,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((formFields.value.payment_method.billing_address_attributes.country) = $event)),
                        class: "form-select",
                        required: ""
                      }, [
                        _hoisted_64,
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(countryList, (country) => {
                          return _createElementVNode("option", { key: country }, _toDisplayString(country), 1)
                        }), 64))
                      ], 512), [
                        [_vModelSelect, formFields.value.payment_method.billing_address_attributes.country]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (
          !formFields.value.payment_method.autopay_enabled &&
          _unref(api_settings).saving_resusable_card
        )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formFields.value.payment_method.reuseable) = $event)),
                        class: "form-check-input",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, formFields.value.payment_method.reuseable]
                      ]),
                      _hoisted_66,
                      _hoisted_67,
                      _hoisted_68
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (formErrors.value.server_error !== undefined)
            ? (_openBlock(), _createBlock(_component_BaseAlert, {
                key: 6,
                variant: "danger",
                class: "js-form-error",
                dismissible: "",
                onDismissed: _cache[28] || (_cache[28] = ($event: any) => (formErrors.value = {}))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(formErrors.value.server_error[0]), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
  ], 64))
}
}

})